export default __webpack_public_path__ + "static/media/gsk_Logo.bcf6faca.png";